export enum WorkflowStepFunctionListFieldName {
  Name = 'name',
  subscribedEvents = 'subscribedEvents',
  PublishedEvents = 'publishedEvents',
  Type = 'type',
  HasTransformation = 'hasTransformation',
  HasCustomCode = 'hasCustomCode',
  DeleteStepFunction = 'deleteStepFunction',
}
